// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IJGV","placeholdersHeader":"styles_placeholdersHeader__Dwx2_","editorStyle":"styles_editorStyle__1H1qU","placeholdersBox":"styles_placeholdersBox__1ThCn"};